import React, { useEffect, useState } from 'react';
import api from '../../services/api';

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('todos');

  useEffect(() => {
    api.get('/admin/leads')
      .then(({ data }) => {
        setLeads(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const formatDateTime = (d) => {
    const date = new Date(d);
    return date.toLocaleDateString('pt-BR') + ' ' + date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  };

  const filtered = filter === 'todos' ? leads : leads.filter((l) => (l.source || 'busca') === filter);

  const filterBtn = (value, label) => (
    <button
      key={value}
      type="button"
      className={`btn-secondary${filter === value ? ' active' : ''}`}
      style={{
        padding: '8px 16px',
        border: filter === value ? 'none' : '1px solid var(--borda)',
        opacity: filter === value ? 1 : 0.75,
      }}
      onClick={() => setFilter(value)}
    >
      {label}
      {value !== 'todos' && (
        <span style={{ marginLeft: 8, fontWeight: 600 }}>
          {leads.filter((l) => (l.source || 'busca') === value).length}
        </span>
      )}
    </button>
  );

  return (
    <div>
      <div className="page-header">
        <h1>Leads</h1>
        <p>Tabela completa de leads captados.</p>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {filterBtn('todos', 'Todos')}
        {filterBtn('busca', 'Busca')}
        {filterBtn('web', 'Web')}
        {filterBtn('atendimento', 'Atendimento')}
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Origem</th>
              <th>Nome</th>
              <th>Telefone</th>
              <th>E-mail</th>
              <th>Pesquisado / Assunto</th>
              <th>Mensagem</th>
              <th>Local</th>
              <th>Autorizado</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="9" style={{ textAlign: 'center', padding: 40 }}>Carregando...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan="9" style={{ textAlign: 'center', padding: 40, color: 'var(--texto-secundario)' }}>Nenhum lead captado ainda.</td></tr>
            ) : filtered.map((l) => {
              const isWeb = l.source === 'web';
              return (
                <tr key={l.id}>
                  <td>{formatDateTime(l.created_at)}</td>
                  <td>
                    {isWeb
                      ? <span className="badge badge-info">Web</span>
                      : l.source === 'atendimento'
                        ? <span className="badge badge-success">Atendimento</span>
                        : <span className="badge badge-warning">Busca</span>}
                  </td>
                  <td><strong>{l.name}</strong></td>
                  <td>{l.phone}</td>
                  <td>{l.email || <span style={{ color: 'var(--texto-secundario)' }}>—</span>}</td>
                  <td>{(isWeb ? l.subject : l.search_term) || <span style={{ color: 'var(--texto-secundario)' }}>—</span>}</td>
                  <td style={{ maxWidth: 220, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {l.message || <span style={{ color: 'var(--texto-secundario)' }}>—</span>}
                  </td>
                  <td>{l.block ? `Q${l.block} / ${l.sector} / Jazigo ${l.number}` : <span style={{ color: 'var(--texto-secundario)' }}>—</span>}
                    {l.deceased_name && <div style={{ fontSize: '.8rem', color: 'var(--texto-secundario)' }}>{l.deceased_name}</div>}
                  </td>
                  <td>{l.consent ? <span className="badge badge-info">Sim</span> : <span className="badge badge-warning">Não</span>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
